"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactInfoBox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const ComponentContainer_1 = require("../ComponentContainer");
const featureFlag_1 = require("../../featureFlag");
const initializer_1 = require("../../initializer");
const translations_1 = require("../../translations");
const eventBus_1 = require("../../eventBus");
const sharedInfo_1 = require("../../sharedInfo");
const constants_1 = require("./constants");
const ContactInfoBox = () => {
    const history = (0, react_router_dom_1.useHistory)();
    sharedInfo_1.setSharedInfo.setData({
        history,
        featureFlag: (0, featureFlag_1.getFeatureFlag)(),
        sessionData: initializer_1.Session.getData(),
        eventBus: (0, eventBus_1.getGlobalEventBus)(),
        translations: {
            web: (0, translations_1.getTranslationsLoaded)().entries,
            config: (0, translations_1.getConfigTranslationsLoaded)().entries,
        },
    });
    return (0, jsx_runtime_1.jsx)(ComponentContainer_1.ComponentContainer, { componentName: constants_1.CONTACT_INFO_BOX });
};
exports.ContactInfoBox = ContactInfoBox;
//# sourceMappingURL=ContactInfoBox.js.map